import {
  GET_ITENS_MENU,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from "./actionType";

const INIT_STATE = {
  itens: [],
  error: {},
};

const Menu = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_ITENS_MENU:
          return {
            ...state,
            itens: action.payload.data.data,
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_ITENS_MENU:
          return {
            ...state,
            error: action.payload.error,
          };
        default:
          return { ...state };
      }
    case GET_ITENS_MENU: {
      return {
        ...state,
      };
    }
    default:
      return { ...state };
  }
};

export default Menu;
